import {parseUrl} from './UrlFormat'

const getCommentTypeId = (contentType) => {
  let typeId = 0
  let type = parseInt(contentType) || 0
  switch (type) {
    case 51:
    case 52:
    case 53:
      typeId = 5
      break
    case 61:
    case 62:
    case 63:
      typeId = 4
      break
    case 44:
    case 43:
    case 41:
      typeId = 13
      break
    case 25:
    case 26:
    case 27:
      typeId = 12
      break
    case 81:
    case 82:
    case 83:
    case 84:
      typeId = 14
      break
    case 91:
    case 92:
    case 93:
      typeId = 18
      break
    case 33:
    case 32:
    case 31:
      typeId = 9
      break
    case 21:
    case 22:
    case 23:
    case 24:
      typeId = 22
      break
    // 3是导航，1是页面
    case 1:
      typeId = 27
      break
  }
  return typeId
}

const defaultComponentList = [
  {
    type: 5,
    style: {
      'mLeft': 0,
      'mRight': 0,
      'mTop': 0,
      'wBgColor': 'white',
      'height': 0,
    },
    extension: {
      showMenuTitle: 0,
      title: '',
      hasSpaceLine: 0,
      hasIcon: 0,
      isDefaultIcon: 0,
      defaultIconColor: '#19be6b',
      iconUrl: '',
      hasRightAngle: 1,
      hasShadow: 3,
      alignment: 0,
      columnCount: 1,
      pagePlay: 0,
      rowCount: 1,
      lineLimit: 0,
      ratio: 2,
      ratioValue: (4 / 3).toFixed(5),
      titleColor: '#333333',
      titleSize: 16,
      showVideoTitle: 0,
      showTopBorder: 0,
      topBorderColor: '#f1f7fd',
      topBorderHeight: 7,
      showTime: 1,
    },
    layout: {
      type: 3,
      style: JSON.stringify({
        height: 176,
        width: 176,
        hSpacing: 14,
        vSpacing: 0,
        videoWidth: 120
      })
    },
    contentLink: '',
    contentType: 1
  }, {
    type: 4,
    style: {
      'mLeft': 0,
      'mRight': 0,
      'mTop': 0,
      'wBgColor': 'white',
      'height': 0,
    },
    extension: {
      showMenuTitle: 0,
      title: '',
      hasSpaceLine: 0,
      hasIcon: 0,
      isDefaultIcon: 0,
      defaultIconColor: '#19be6b',
      iconUrl: '',
      hasRightAngle: 1,
      hasShadow: 3,
      alignment: 0,
      hOrientation: 1,
      isAutoHeight: 1,
      columnCount: 2,
      ratio: 2,
      lineLimit: 0,
      rowCount: 1,
      ratioValue: 1,
      titleColor: '#333333',
      titleSize: 16,
      showTopBorder: 0,
      topBorderColor: '#f1f7fd',
      topBorderHeight: 7,
      autoTurn: 0,
      showDots: 0
    },
    layout: {
      type: 2,
      style: JSON.stringify({
        height: 176,
        width: 176,
        hSpacing: 0,
        vSpacing: 0,
        subDisplayType: 1
      })
    },
    contentLink: '',
    contentType: 1
  }, {
    type: 13,
    style: {
      'mLeft': 0,
      'mRight': 0,
      'mTop': 0,
      'wBgColor': 'white',
      'height': 0,
    },
    extension: {
      showMenuTitle: 0,
      title: '',
      hasSpaceLine: '',
      hasIcon: 0,
      isDefaultIcon: 0,
      defaultIconColor: '#19be6b',
      iconUrl: '',
      hasRightAngle: 1,
      hasShadow: 3,
      alignment: 0,
      rowCount: 1,
      lineLimit: 0,
      titleColor: '#333333',
      titleSize: 16,
      ratio: 1,
      ratioValue: (4 / 3).toFixed(5),
      showTopBorder: 0,
      topBorderColor: '#f1f7fd',
      topBorderHeight: 7
    },
    layout: {
      type: 1,
      style: JSON.stringify({
        hSpacing: 0,
        vSpacing: 0,
        itemWidth: 120
      })
    },
    contentLink: '',
    contentType: 1
  }, {
    type: 12,
    style: {
      'mLeft': 0,
      'mRight': 0,
      'mTop': 0,
      'wBgColor': 'white',
      'height': 0,
    },
    extension: {
      showMenuTitle: 0,
      title: '',
      hasSpaceLine: '',
      hasIcon: 0,
      isDefaultIcon: 0,
      defaultIconColor: '#19be6b',
      iconUrl: '',
      hasRightAngle: 1,
      hasShadow: 3,
      alignment: 0,
      rowCount: 1,
      lineLimit: 0,
      titleColor: '#333333',
      titleSize: 16,
      ratio: 1,
      ratioValue: (4 / 3).toFixed(5),
      showTopBorder: 0,
      topBorderColor: '#f1f7fd',
      topBorderHeight: 7
    },
    layout: {
      type: 1,
      style: JSON.stringify({
        hSpacing: 0,
        vSpacing: 0
      })
    },
    contentLink: '',
    contentType: 1
  }, {
    type: 14,
    style: {
      'mLeft': 0,
      'mRight': 0,
      'mTop': 0,
      'wBgColor': 'white',
      'height': 0,
    },
    extension: {
      showMenuTitle: 0,
      title: '',
      hasSpaceLine: 0,
      hasIcon: 0,
      isDefaultIcon: 1,
      defaultIconColor: '#19be6b',
      iconUrl: '',
      hasRightAngle: 1,
      hasShadow: 3,
      alignment: 0,
      rowCount: 1,
      columnCount: 1,
      lineLimit: 0,
      titleColor: '#333333',
      titleSize: 16,
      callenable: 1,
      showTopBorder: 0,
      topBorderColor: '#f1f7fd',
      topBorderHeight: 7
    },
    layout: {
      type: 1,
      style: JSON.stringify({
        hSpacing: 0,
        vSpacing: 0,
        subDisplayType: 1,
        cardBgColor: '#F8F8F9'
      })
    },
    contentLink: '',
    contentType: 1
  }, {
    type: 18,
    style: {
      'mLeft': 0,
      'mRight': 0,
      'mTop': 0,
      'wBgColor': 'white',
      'height': 0,
    },
    extension: {
      showMenuTitle: 0,
      title: '',
      hasSpaceLine: 0,
      hasIcon: 0,
      isDefaultIcon: 0,
      defaultIconColor: '#19be6b',
      iconUrl: '',
      hasRightAngle: 1,
      hasShadow: 3,
      alignment: 0,
      titleColor: '#333333',
      titleSize: 16,
      showTopBorder: 0,
      topBorderColor: '#f1f7fd',
      topBorderHeight: 7,
      hasComment: 1
    },
    layout: {
      type: 1,
      style: JSON.stringify({
        hSpacing: 5,
        vSpacing: 5
      })
    },
    contentLink: '',
    contentType: 1
  }, {
    type: 9,
    style: {
      'mLeft': 0,
      'mRight': 0,
      'mTop': 0,
      'wBgColor': 'white',
      'height': 0,
    },
    extension: {
      showMenuTitle: 0,
      title: '',
      hasSpaceLine: 1,
      hasIcon: 0,
      isDefaultIcon: 1,
      iconUrl: '',
      hasRightAngle: 1,
      hasShadow: 3,
      alignment: 0,
      rowCount: 1,
      lineLimit: 0,
      titleColor: '#333333',
      titleSize: 16,
      showPrice: 1,
      showTopBorder: 0,
      topBorderColor: '#f1f7fd',
      topBorderHeight: 7,
      hasComment: 1,
    },
    layout: {
      type: 1,
      style: JSON.stringify({
        subDisplayType: 1
      })
    },
    contentLink: '',
    contentType: 1,
  }, {
    typeId: 22,
    extension: {
      //组件配置
      showMenuTitle: 0,
      title: '',
      hasSpaceLine: 1,
      hasIcon: 0,
      isDefaultIcon: 1,
      iconUrl: '',
      hasRightAngle: 1,
      hasShadow: 3,
      alignment: 0,
      rowCount: 1,
      lineLimit: 0,
      titleColor: '#333333',
      titleSize: 16,
      showPrice: 0,
      showTopBorder: 0,
      topBorderColor: '#f1f7fd',
      topBorderHeight: 7,
    },
    layout: {
      type: 1,
      style: JSON.stringify({
        subDisplayType: 2
      })
    },
    contentLink: '',
    contentType: 1,
  }
]

const getComponentInfo = (typeId) => {
  let info = {}
  let infolist = defaultComponentList.filter(res => {
    return res.type === typeId
  })
  if (infolist && infolist.length) {
    info = infolist[0]
  }
  return JSON.parse(JSON.stringify(info))
}

function getLeftVideoValue (radio) {
  switch (radio) {
    case 1:
      return 69
    case 2:
      return 120
    case 3:
      return 92
    case 5:
      return 120
  }
}

function getProLeftVideoValue (radio) {
  switch (radio) {
    case 1:
      return 100
    case 2:
      return 120
    case 3:
      return 92
    case 5:
      return 120
  }
}

function getRatioValue (ratio) {
  switch (ratio) {
    case 1:
      return 1
    case 2:
      return (4 / 3).toFixed(5)
    case 3:
      return (16 / 9).toFixed(5)
    case 5:
      return (5 / 4).toFixed(5)
  }
}

function fotmatInfos (extension, layout, jumpObj, typeId, usedefault, jumpFromTypeId = -1) {
  if (!usedefault) {
    layout.type = jumpObj.displayType || 0
  }
  let layoutStyle = layout.style ? JSON.parse(layout.style) : {}
  switch (typeId) {
    case 5:
      if (!usedefault){
        layoutStyle.vSpacing = jumpObj.vSpacing
        layoutStyle.hSpacing = jumpObj.hSpacing
        extension.ratio = jumpObj.ratio
        extension.ratioValue = getRatioValue(jumpObj.ratio)
      }
      extension.showVideoTitle = jumpObj.showVideoTitle
      layoutStyle.videoWidth = getLeftVideoValue(jumpObj.ratio)
      break
    case 4:
      layoutStyle.vSpacing = jumpObj.vSpacing
      layoutStyle.hSpacing = jumpObj.hSpacing
      if (!usedefault) {
        layoutStyle.subDisplayType = jumpObj.subDisplayType
      }
      extension.ratio = jumpObj.ratio

      if (jumpFromTypeId === 3) {   //导航菜单式 单列显示
        extension.ratio = 4         //ratio=4 自适应高度
        layout.type = 2
      } else {                      //其他 双列
        layout.type = 2
        extension.columnCount = 2
      }

      extension.ratioValue = getRatioValue(jumpObj.ratio)
      if (jumpObj.columnCount)      //columnCount:undefined
        extension.columnCount = jumpObj.columnCount
      break
    case 13:
      layoutStyle.vSpacing = jumpObj.vSpacing
      layoutStyle.hSpacing = jumpObj.hSpacing
      extension.ratio = jumpObj.ratio
      extension.ratioValue = getRatioValue(jumpObj.ratio)
      layoutStyle.itemWidth = getLeftVideoValue(jumpObj.ratio)
      break
    case 12:
      layoutStyle.vSpacing = jumpObj.vSpacing
      layoutStyle.hSpacing = jumpObj.hSpacing
      break
    case 14:
      layoutStyle.vSpacing = jumpObj.vSpacing
      layoutStyle.hSpacing = jumpObj.hSpacing
      if (!usedefault) {
        layoutStyle.subDisplayType = jumpObj.subDisplayType
      }
      break
    case 18:
      layoutStyle.vSpacing = jumpObj.vSpacing || 5
      layoutStyle.hSpacing = jumpObj.hSpacing || 10
      break
    case 9:
      layoutStyle.subDisplayType = jumpObj.subDisplayType || 2
      layoutStyle.vSpacing = jumpObj.vSpacing || 10
      layoutStyle.hSpacing = jumpObj.hSpacing || 10

      extension.ratio = jumpObj.ratio || 1
      extension.ratioValue = getRatioValue(extension.ratio)

      let proRatio = 1
      if (jumpObj.displayType === 1 && jumpObj.subDisplayType === 1) {
        proRatio = 2
      }
      let columnCount = 1
      if (jumpObj.displayType === 3) {
        columnCount = 2
      }
      layoutStyle.itemWidth = getProLeftVideoValue(proRatio)
      break
    case 22:
      if (!usedefault) {
        layoutStyle.subDisplayType = jumpObj.subDisplayType
      }
      layoutStyle.vSpacing = jumpObj.vSpacing
      layoutStyle.hSpacing = jumpObj.hSpacing
      break
  }
  layout.style = JSON.stringify(layoutStyle)

  // console.log('extension:', extension)
  // console.log('layout:', layout)
}

export const getComponentWidget = (jumpObj, contentType = 0, typeId_w, usedefault = false) => {
  let typeId = 0
  let style = {}
  let extension = {}
  let defaultInfo = {}
  let layout = {
    'mLeft': 0,
    'mRight': 0,
    'mTop': 0,
    'wBgColor': 'white',
    'height': 0,
  }
  if (jumpObj.linkUrl) {
    let params = parseUrl(jumpObj.linkUrl)
    if (params && params.contentType) {
      typeId = getCommentTypeId(params.contentType)
      if (typeId) {
        defaultInfo = getComponentInfo(typeId)
        style = defaultInfo.style || {}
        extension = defaultInfo.extension || {}
        layout = defaultInfo.layout || {}
        fotmatInfos(extension, layout, jumpObj, typeId, usedefault, typeId_w)
      }
    }
  } else {
    if (typeId_w) {
      defaultInfo = getComponentInfo(typeId_w)
      style = defaultInfo.style || {}
      extension = defaultInfo.extension || {}
      layout = defaultInfo.layout || {}
      fotmatInfos(extension, layout, jumpObj, typeId_w, usedefault)
    }
  }
  let linkcontentType = contentType
  if (!usedefault) {
    linkcontentType = contentType
  } else {
    linkcontentType = 1
  }
  let info = {
    type: typeId,
    style: JSON.stringify(style),
    extension: JSON.stringify(extension),
    layout: layout,
    contentList: [],
    contentLink: {
      link: jumpObj.linkUrl || '',
      title: jumpObj.linkName || ''
    },
    contentType: linkcontentType,
    shareCover: jumpObj.shareCover || '',
    shareTitle: jumpObj.shareTitle || ''
  }
  return info
}
